import React from "react";
import { PricingProduct } from "./PricingProduct";
interface Props {
  priceIncreaseAdvertisement: PricingProduct["priceIncreaseAdvertisement"];
}
const PriceIncreaseAdvertisement = ({
  priceIncreaseAdvertisement: {
    endDate,
    endPercentIncrease,
    priceIncreaseDate,
    startDate,
    startPercentIncrease
  }
}: Props) => {
  const currentDate = new Date();
  return <>
      {currentDate > new Date(startDate) && currentDate < new Date(endDate) && <div className="alert alert-general">
          <i className="icon-attention" />
          <div data-testid="price-increase">
            Due to a manufacturer&apos;s price increase, this price will
            increase by
            <strong>{` ${startPercentIncrease.toFixed(2)}% `}</strong>
            {startPercentIncrease !== endPercentIncrease && <>
                to
                <strong>{` ${endPercentIncrease.toFixed(2)}% `}</strong>
              </>}
            {`on ${new Date(priceIncreaseDate).toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "2-digit"
        })}`}
          </div>
        </div>}
    </>;
};
export default PriceIncreaseAdvertisement;